import logo from './logo.svg';
import './App.css';
import Alarm from './Alarm/alarm';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
   <>
   <Alarm/>
   </>
  );
}

export default App;
